// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn.HighlightLinkButton-module__highlight___dNRA{padding-top:1.5px;font-size:2.5rem;line-height:2.5rem;font-family:'Gotham Bold';min-height:3rem;color:#064785;border-radius:0;border-bottom:1px solid #064785;display:flex;align-items:center}.btn.HighlightLinkButton-module__withHref__RwzJN>a{color:#064785}.btn.HighlightLinkButton-module__withHref__RwzJN>a:hover,.btn.HighlightLinkButton-module__withHref__RwzJN>a:focus{text-decoration:none}.btn.HighlightLinkButton-module__withoutHref__uYsks:hover,.btn.HighlightLinkButton-module__withoutHref__uYsks:focus{color:#064785;text-decoration:none}\n", ""]);
// Exports
exports.locals = {
	"highlight": "HighlightLinkButton-module__highlight___dNRA",
	"withHref": "HighlightLinkButton-module__withHref__RwzJN",
	"withoutHref": "HighlightLinkButton-module__withoutHref__uYsks"
};
module.exports = exports;
